import { useMemo, useState } from "react";
import { Archive, Search } from "lucide-react";
import { it } from "date-fns/locale";
import { Calendar } from "./ui/calendar";
import { Input } from "./ui/input";
import { Empty } from "./common";

const dayKey = (iso) => new Date(iso).toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" });
const keyOf = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const text = (a) => `${a.categoria} ${a.messaggio || ""} ${a.from_name || ""} ${a.resolved_by_name || ""} ${a.severita || ""}`.toLowerCase();

function Archivio({ alerts, render }) {
  const days = useMemo(() => new Set(alerts.map((a) => dayKey(a.created_at))), [alerts]);
  const [day, setDay] = useState(null);
  const [q, setQ] = useState("");
  const [month, setMonth] = useState(() => (alerts[0] ? new Date(alerts[0].created_at) : new Date()));
  const shown = q.trim() ? alerts.filter((a) => text(a).includes(q.trim().toLowerCase())) : day ? alerts.filter((a) => dayKey(a.created_at) === keyOf(day)) : [];
  return (
    <section className="mt-10" data-testid="alerts-archive">
      <h3 className="flex items-center gap-2 font-display text-lg font-bold text-[var(--navy)] mb-4"><Archive className="w-5 h-5 text-[var(--teal)]" />Archivio alert risolti ({alerts.length})</h3>
      <div className="grid lg:grid-cols-[auto,1fr] gap-6 items-start">
        <div className="panel !p-2 w-fit" data-testid="alerts-archive-calendar">
          <Calendar locale={it} mode="single" selected={day} onSelect={(d) => { setDay(d || null); setQ(""); }} month={month} onMonthChange={setMonth} weekStartsOn={1}
            modifiers={{ conAlert: (d) => days.has(keyOf(d)) }} modifiersClassNames={{ conAlert: "font-bold text-[var(--teal)] underline underline-offset-4" }} />
        </div>
        <div className="space-y-4 min-w-0">
          <div className="relative max-w-md"><Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" /><Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca negli alert risolti" className="pl-9" data-testid="alerts-archive-search" /></div>
          <p className="text-sm text-slate-500" data-testid="alerts-archive-hint">{q.trim() ? `${shown.length} risultati per "${q.trim()}"` : day ? `${shown.length} alert del ${day.toLocaleDateString("it-IT")}` : "Seleziona un giorno sul calendario (i giorni con alert sono sottolineati) o cerca per testo."}</p>
          {(q.trim() || day) && (shown.length ? <div className="space-y-3">{shown.map(render)}</div> : <Empty title="Nessun alert risolto trovato" />)}
        </div>
      </div>
    </section>
  );
}

export function AlertsTab({ alerts, render }) {
  const open = alerts.filter((a) => !a.resolved);
  const done = alerts.filter((a) => a.resolved);
  return (
    <div data-testid="alerts-tab">
      <h3 className="font-display text-lg font-bold text-[var(--navy)] mb-4">Alert da risolvere ({open.length})</h3>
      {open.length ? <div className="space-y-3 stagger" data-testid="alerts-open">{open.map(render)}</div> : <Empty title="Nessun alert da risolvere" />}
      <Archivio alerts={done} render={render} />
    </div>
  );
}
